<template>
  <nx-entity-selector
    v-validate="validation"
    :data-vv-name="name"
    :data-vv-scope="scope"
    :data-vv-as="label"
    :error-messages="errorMessages"
    data-vv-validate-on="input"
    data-vv-value-path="value"
    :label="label"
    :custom-filters="customFilters"
    :limit="limit"
    :entity="entity"
    :disabled="disabled"
    :disable-delete="disableDelete"
    :disable-search="disableSearch"
    :item-text-key="itemTextKey"
    :item-value-key="itemValueKey"
    :allow-edit-items="allowEditItems"
    :show-wizard-if-filled="showWizardIfFilled"
    :readonly="readonly"
    :icon="icon"
    :formated-items="formattedItems"
    :value="value"
    :wizard="wizard"
    :open-modal-editor="openModalEditor"
    @input="onInput"
  />
</template>

<script>
import get from 'lodash/get';
import FormElement from '@/modules/form/mixins/form-element';

export default {
  name: 'NxEntityFormSelector',
  inject: {
    $getParentEditor: { default: null },
  },
  mixins: [FormElement],
  props: {
    allowEditItems: {
      type: Boolean,
      default: true,
    },
    entity: {
      type: String,
      required: true,
    },
    customFilters: {
      type: Object,
      default: undefined,
    },
    icon: {
      type: String,
      default: undefined,
    },
    itemValueKey: {
      type: String,
      default: 'id',
    },
    itemTextKey: {
      type: String,
      default: 'name',
    },
    value: {
      type: [Object, Array],
    },
    wizard: {
      type: String,
      default: undefined,
    },
    limit: {
      type: Number,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableSearch: {
      type: Boolean,
    },
    disableDelete: {
      type: Boolean,
    },
    name: {
      type: String,
      default: undefined,
    },
    type: {
      type: [Object, Array],
      default: undefined,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    openModalEditor: {
      type: Boolean,
    },
    showWizardIfFilled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formattedItems: [],
    };
  },
  watch: {
    value(v) {
      if (v) {
        this.formattedItems = v;
      }
    },
  },
  mounted() {
    this.formattedItems = this.getAdMapValueFromBoardEditor() || this.value;
  },
  methods: {
    // ODMPPHE
    // Este fix se introdujo en una tarea de ARA, porque el selector de AdMaps estaba fallando en el editor de los
    // metadatos de las portadas. Parece que ya no es necesario, pero lo mantenemos por si acaso.
    // @see https://mgr.bitban.com/issues/94287
    getAdMapValueFromBoardEditor() {
      if (!this.$getParentEditor) {
        return null;
      }

      const parentEditor = this.$getParentEditor();
      const parentEditorEntity = get(parentEditor, 'state.entity');

      if (this.entity !== 'adMap'
        || parentEditorEntity !== 'board'
      ) {
        return null;
      }

      const draftValue = get(parentEditor, `state.draft.${this.name}`);
      if (!draftValue) {
        return null;
      }

      if (!draftValue.id || !draftValue.name) {
        return null;
      }

      return {
        [this.itemValueKey]: draftValue.id,
        [this.itemTextKey]: draftValue.name,
      };
    },
    async onInput(entity) {
      if (!entity) {
        this.formattedItems = [];
      }
      const value = entity && entity.id ? entity.id : null;
      this.$parentForm.updateField(this.name, entity);
      this.$emit('input', value, entity || null);
    },
  },
};
</script>
